module.exports = __webpack_public_path__ + "static/media/more_horiz_black_24dp.2ff05e32.svg";